import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "en", setLang: () => {}, t: null });
export const useLang = () => useContext(LangContext);

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "hi", label: "हिं" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
];

export const WHATSAPP = [
  { num: "919252211011", label: "+91 92522 11011" },
  { num: "919782898979", label: "+91 97828 98979" },
  { num: "919314451570", label: "+91 93144 51570" },
];

export const waLink = (index, text = "") =>
  `https://wa.me/${WHATSAPP[index % WHATSAPP.length].num}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const COPY = {
  en: {
    nav: { about: "About", services: "Services", collections: "Collections", tours: "Tours", gallery: "Gallery", contact: "Contact", cta: "Book a Private Tour" },
    hero: {
      kicker: "Explore Indians · Private Luxury Journeys",
      lines: ["Experience", "the Soul", "of India"],
      sub: "Welcome to an incredible journey through India — a rare confluence of history, culture and natural beauty. From the spellbinding Taj Mahal to the royal heritage of Rajasthan, every step reveals a new experience.",
      ctaPrimary: "Plan My Journey",
      ctaSecondary: "Chat on WhatsApp",
      badges: ["Govt. Certified Guides", "24/7 Concierge", "100% Tailor-made"],
      scroll: "Scroll to explore",
    },
    marquee: ["ROYAL RAJASTHAN", "GOLDEN TRIANGLE", "PRIVATE LUXURY CHAUFFEURS", "CERTIFIED HERITAGE GUIDES", "PALACE & HAVELI STAYS", "EXPERIENCE THE SOUL OF INDIA"],
    about: {
      kicker: "About Us",
      title: "A Complete Indian Journey, Curated for You",
      body: "We provide travellers in India with a complete, seamless travel experience. Our promise covers every detail:",
      bullets: [
        "Experienced & reliable private taxi chauffeurs",
        "Handpicked heritage hotels, palaces & havelis",
        "Guided visits to historical heritage sites & monuments",
        "A commitment to fulfilling every need of our guests",
      ],
      stats: [
        { n: "10+", l: "Signature Tours" },
        { n: "7", l: "Iconic Destinations" },
        { n: "3", l: "Concierge Lines" },
        { n: "24/7", l: "Guest Support" },
      ],
    },
    services: {
      kicker: "Our Premium Services",
      title: "Travel Like Royalty",
      items: [
        { title: "Experienced Chauffeurs & Cabs", desc: "For safe, comfortable and punctual road journeys, our fleet of courteous, experienced drivers knows every local route intimately." },
        { title: "Heritage Hotels & Stays", desc: "Stay in royal splendour — palaces and traditional havelis arranged specially for you, so you can live India's rich history and legendary hospitality." },
        { title: "Certified Guides & Escorts", desc: "Government-licensed, multilingual guides who bring monuments, art and culture alive — with dedicated tour escorts accompanying you throughout the journey." },
      ],
    },
    collections: {
      kicker: "Special Tour Packages",
      title: "Four Worlds of India",
      sub: "To experience the diversity and astounding heritage of India, we have crafted signature collections for you. Each one carries you into a different world.",
      items: [
        { name: "Royal Rajasthan", desc: "Experience royal palaces, mighty forts and desert culture.", points: ["Amer Fort, Jaipur", "Mehrangarh Fort, Jodhpur", "Lakes of Udaipur"] },
        { name: "Golden Tulip", desc: "Journey through historic sites wrapped in modern comfort and restful stays.", points: ["Boutique luxury stays", "Curated city experiences", "Private transfers"] },
        { name: "Golden Triangle", desc: "The grand confluence of Delhi, Agra and Jaipur.", points: ["Qutub Minar, Delhi", "Taj Mahal, Agra", "Hawa Mahal, Jaipur"] },
        { name: "Heritage Rajasthan", desc: "Experience Rajasthan's cultural heritage and traditional way of life.", points: ["Brahma Temple, Pushkar", "Khajuraho Temples"] },
      ],
    },
    tours: { kicker: "The Signature Collection", title: "Ten Journeys. One Soul.", sub: "Every itinerary is private, chauffeur-driven and fully tailor-made. Choose your journey — we craft the rest.", enquire: "Enquire", whatsapp: "WhatsApp", viewTour: "View Journey", priceOnRequest: "Price on request" },
    gallery: { kicker: "The Gallery", title: "India, Frame by Frame", sub: "A glimpse of the monuments, forts and sacred shores awaiting you." },
    testimonials: { kicker: "Guest Stories", title: "Words From Our Travellers" },
    td: { back: "All Tours", overview: "The Journey", itinerary: "Day-by-Day Itinerary", highlights: "Highlights", inclusions: "What's Included", day: "Day", enquire: "Enquire About This Tour" },
    enquiry: {
      kicker: "Begin Your Journey",
      title: "Request a Private Quote",
      sub: "Tell us your dream route — our concierge replies within hours with a tailor-made plan.",
      fields: { name: "Full Name", email: "Email", phone: "Phone / WhatsApp", tour: "Choose a Tour", date: "Preferred Travel Date", guests: "Guests", tier: "Hotel Tier", message: "Tell us more (optional)" },
      tiers: ["Heritage Boutique", "Luxury Palace", "Royal Signature"],
      submit: "Send Enquiry",
      sending: "Sending…",
      success: "Namaste! Your enquiry has been received. Our concierge will contact you shortly.",
      whatsappCta: "Continue on WhatsApp",
    },
    footer: { tagline: "Experience the Soul of India", blurb: "Premium private journeys across India — chauffeurs, palaces and certified storytellers, crafted around you.", explore: "Explore", contact: "Concierge Desk", rights: "All rights reserved." },
    chat: {
      title: "Royal Assistant",
      subtitle: "Official travel concierge of Explore India",
      greeting: "Namaste! I am Royal Assistant, the official travel concierge of Explore India. How may I help you plan your journey today?",
      placeholder: "Ask about tours, prices, itineraries…",
      send: "Send",
      quick: ["Golden Triangle price?", "Best time to visit Rajasthan?", "7-day family itinerary"],
      error: "I am momentarily unavailable. Please reach us on WhatsApp at +91 9252211011.",
    },
    whatsapp: { title: "Concierge on WhatsApp", labels: ["Golden Triangle Expert", "Royal Rajasthan Specialist", "24/7 Concierge Desk"] },
  },
  hi: {
    nav: { about: "हमारे बारे में", services: "सेवाएँ", collections: "संग्रह", tours: "टूर", gallery: "गैलरी", contact: "संपर्क", cta: "निजी टूर बुक करें" },
    hero: {
      kicker: "एक्सप्लोर इंडियन्स · निजी लक्ज़री यात्राएँ",
      lines: ["अनुभव करें", "भारत की", "आत्मा"],
      sub: "भारत की अद्भुत यात्रा में आपका स्वागत है! यहाँ आपको मिलेगा इतिहास, संस्कृति और प्राकृतिक सुंदरता का अनोखा संगम। ताजमहल की मोहकता से लेकर राजस्थान की शाही विरासत तक, हर कदम पर आपको नए अनुभव मिलेंगे।",
      ctaPrimary: "मेरी यात्रा की योजना बनाएं",
      ctaSecondary: "व्हाट्सऐप पर चैट करें",
      badges: ["सरकारी प्रमाणित गाइड", "24/7 कंसीयज", "100% कस्टम-मेड"],
      scroll: "देखने के लिए स्क्रॉल करें",
    },
    marquee: ["रॉयल राजस्थान", "गोल्डन ट्राइएंगल", "निजी लक्ज़री चालक", "प्रमाणित हेरिटेज गाइड", "महल एवं हवेली स्टे", "भारत की आत्मा का अनुभव करें"],
    about: {
      kicker: "हमारे बारे में",
      title: "आपके लिए तैयार की गई संपूर्ण भारतीय यात्रा",
      body: "हम भारत में पर्यटकों को एक संपूर्ण यात्रा अनुभव प्रदान करते हैं। हमारी सेवाओं में शामिल हैं:",
      bullets: [
        "अनुभवी एवं विश्वसनीय टैक्सी ड्राइवर्स",
        "चुनिंदा हेरिटेज होटल, महल एवं हवेलियाँ",
        "ऐतिहासिक धरोहरों और विरासत स्थलों का दौरा",
        "ग्राहकों की हर ज़रूरत को पूरा करने की प्रतिबद्धता",
      ],
      stats: [
        { n: "10+", l: "सिग्नेचर टूर" },
        { n: "7", l: "प्रतिष्ठित गंतव्य" },
        { n: "3", l: "कंसीयज लाइनें" },
        { n: "24/7", l: "अतिथि सहायता" },
      ],
    },
    services: {
      kicker: "हमारी प्रमुख सेवाएँ",
      title: "शाही अंदाज़ में यात्रा करें",
      items: [
        { title: "अनुभवी एवं विश्वसनीय टैक्सी ड्राइवर्स", desc: "सड़क मार्ग से सुरक्षित, आरामदायक और समयबद्ध यात्रा के लिए हमारे पास स्थानीय रास्तों से भली-भांति परिचित, शालीन और अनुभवी ड्राइवर्स का बेड़ा उपलब्ध है।" },
        { title: "हेरिटेज होटल्स एवं प्रामाणिक ठहराव", desc: "शाही ठाठ-बाट, महलों और पारंपरिक हवेलियों में आपके ठहरने की विशेष व्यवस्था, ताकि आप भारत के समृद्ध इतिहास और आतिथ्य का असली अनुभव ले सकें।" },
        { title: "प्रमाणित टूर गाइड एवं एस्कॉर्ट सेवा", desc: "ऐतिहासिक स्मारकों, कला और संस्कृति को गहराई से समझाने के लिए सरकारी लाइसेंस प्राप्त, बहुभाषी गाइड और संपूर्ण यात्रा में साथ रहने वाले समर्पित टूर एस्कॉर्ट्स।" },
      ],
    },
    collections: {
      kicker: "विशेष टूर पैकेज",
      title: "भारत की चार अनूठी दुनियाएँ",
      sub: "भारत की विविधता और अद्भुत धरोहरों को अनुभव करने के लिए हमने आपके लिए खास पैकेज तैयार किए हैं। हर पैकेज आपको एक अलग ही दुनिया में ले जाएगा।",
      items: [
        { name: "रॉयल राजस्थान", desc: "शाही महलों, किलों और रेगिस्तानी संस्कृति का अनुभव।", points: ["जयपुर का आमेर फोर्ट", "जोधपुर का मेहरानगढ़ फोर्ट", "उदयपुर की झीलें"] },
        { name: "गोल्डन ट्यूलिप", desc: "आधुनिक सुविधाओं और आरामदायक ठहराव के साथ ऐतिहासिक स्थलों की यात्रा।", points: ["बुटीक लक्ज़री स्टे", "क्यूरेटेड शहर अनुभव", "निजी ट्रांसफर"] },
        { name: "गोल्डन ट्राइएंगल", desc: "दिल्ली, आगरा और जयपुर का शानदार संगम।", points: ["दिल्ली का कुतुब मीनार", "आगरा का ताजमहल", "जयपुर का हवा महल"] },
        { name: "हेरिटेज राजस्थान", desc: "राजस्थान की सांस्कृतिक धरोहर और पारंपरिक जीवनशैली का अनुभव।", points: ["पुष्कर का ब्रह्मा मंदिर", "खजुराहो के मंदिर"] },
      ],
    },
    tours: { kicker: "सिग्नेचर संग्रह", title: "दस यात्राएँ। एक आत्मा।", sub: "हर यात्रा-कार्यक्रम निजी, चालक-युक्त और पूरी तरह कस्टम-मेड है। अपनी यात्रा चुनें — बाकी हम सँवारेंगे।", enquire: "पूछताछ करें", whatsapp: "व्हाट्सऐप", viewTour: "यात्रा देखें", priceOnRequest: "मूल्य पूछताछ पर" },
    gallery: { kicker: "गैलरी", title: "भारत, फ्रेम-दर-फ्रेम", sub: "आपकी प्रतीक्षा में मौजूद स्मारकों, किलों और पवित्र तटों की एक झलक।" },
    testimonials: { kicker: "अतिथि कहानियाँ", title: "हमारे यात्रियों की ज़ुबानी" },
    td: { back: "सभी टूर", overview: "यात्रा सार", itinerary: "दिन-प्रतिदिन कार्यक्रम", highlights: "मुख्य आकर्षण", inclusions: "क्या शामिल है", day: "दिन", enquire: "इस टूर की पूछताछ करें" },
    enquiry: {
      kicker: "अपनी यात्रा शुरू करें",
      title: "निजी कोटेशन का अनुरोध करें",
      sub: "हमें अपना सपनों का मार्ग बताएं — हमारा कंसीयज कुछ ही घंटों में कस्टम-मेड योजना के साथ जवाब देगा।",
      fields: { name: "पूरा नाम", email: "ईमेल", phone: "फोन / व्हाट्सऐप", tour: "टूर चुनें", date: "यात्रा की पसंदीदा तिथि", guests: "अतिथि", tier: "होटल श्रेणी", message: "और बताएं (वैकल्पिक)" },
      tiers: ["हेरिटेज बुटीक", "लक्ज़री पैलेस", "रॉयल सिग्नेचर"],
      submit: "पूछताछ भेजें",
      sending: "भेजा जा रहा है…",
      success: "नमस्ते! आपकी पूछताछ प्राप्त हो गई है। हमारा कंसीयज शीघ्र ही आपसे संपर्क करेगा।",
      whatsappCta: "व्हाट्सऐप पर जारी रखें",
    },
    footer: { tagline: "भारत की आत्मा का अनुभव करें", blurb: "भारत भर में प्रीमियम निजी यात्राएँ — चालक, महल और प्रमाणित कथावाचक, आपके लिए तैयार।", explore: "देखें", contact: "कंसीयज डेस्क", rights: "सर्वाधिकार सुरक्षित।" },
    chat: {
      title: "रॉयल असिस्टेंट",
      subtitle: "एक्सप्लोर इंडिया का आधिकारिक ट्रैवल कंसीयज",
      greeting: "नमस्ते! मैं रॉयल असिस्टेंट हूँ, एक्सप्लोर इंडिया का आधिकारिक ट्रैवल कंसीयज। आज मैं आपकी यात्रा की योजना में कैसे मदद कर सकता हूँ?",
      placeholder: "टूर, कीमत, यात्रा-कार्यक्रम के बारे में पूछें…",
      send: "भेजें",
      quick: ["गोल्डन ट्राइएंगल की कीमत?", "राजस्थान घूमने का सबसे अच्छा समय?", "7 दिन का पारिवारिक कार्यक्रम"],
      error: "मैं इस समय उपलब्ध नहीं हूँ। कृपया व्हाट्सऐप +91 9252211011 पर संपर्क करें।",
    },
    whatsapp: { title: "व्हाट्सऐप पर कंसीयज", labels: ["गोल्डन ट्राइएंगल विशेषज्ञ", "रॉयल राजस्थान विशेषज्ञ", "24/7 कंसीयज डेस्क"] },
  },
  es: {
    nav: { about: "Nosotros", services: "Servicios", collections: "Colecciones", tours: "Tours", gallery: "Galería", contact: "Contacto", cta: "Reservar un Tour Privado" },
    hero: {
      kicker: "Explore Indians · Viajes Privados de Lujo",
      lines: ["Descubra", "el Alma", "de la India"],
      sub: "Le damos la bienvenida a un viaje increíble por la India: una fusión única de historia, cultura y belleza natural. Del encanto del Taj Mahal al legado real de Rajastán, cada paso revela una nueva experiencia.",
      ctaPrimary: "Planificar Mi Viaje",
      ctaSecondary: "Chatear por WhatsApp",
      badges: ["Guías Certificados", "Conserjería 24/7", "100% a Medida"],
      scroll: "Desplácese para explorar",
    },
    marquee: ["RAJASTÁN REAL", "TRIÁNGULO DE ORO", "CHÓFERES PRIVADOS DE LUJO", "GUÍAS CERTIFICADOS DE PATRIMONIO", "ESTANCIAS EN PALACIOS Y HAVELIS", "DESCUBRA EL ALMA DE LA INDIA"],
    about: {
      kicker: "Nosotros",
      title: "Un Viaje Completo por la India, Diseñado para Usted",
      body: "Ofrecemos a los viajeros en la India una experiencia completa y sin preocupaciones. Nuestra promesa cubre cada detalle:",
      bullets: [
        "Chóferes privados expertos y de confianza",
        "Hoteles patrimoniales, palacios y havelis seleccionados",
        "Visitas guiadas a monumentos y sitios históricos",
        "El compromiso de cubrir cada necesidad de nuestros huéspedes",
      ],
      stats: [
        { n: "10+", l: "Tours Emblemáticos" },
        { n: "7", l: "Destinos Icónicos" },
        { n: "3", l: "Líneas de Conserjería" },
        { n: "24/7", l: "Atención al Huésped" },
      ],
    },
    services: {
      kicker: "Nuestros Servicios Premium",
      title: "Viaje como la Realeza",
      items: [
        { title: "Chóferes y Coches Expertos", desc: "Para viajes por carretera seguros, cómodos y puntuales, nuestra flota de conductores corteses y experimentados conoce cada ruta local a la perfección." },
        { title: "Hoteles Patrimoniales y Estancias", desc: "Alójese con esplendor real: palacios y havelis tradicionales preparados especialmente para usted, para vivir la rica historia y hospitalidad de la India." },
        { title: "Guías Certificados y Acompañantes", desc: "Guías multilingües con licencia gubernamental que dan vida a monumentos, arte y cultura, con acompañantes dedicados durante todo el viaje." },
      ],
    },
    collections: {
      kicker: "Paquetes Especiales",
      title: "Cuatro Mundos de la India",
      sub: "Para que viva la diversidad y el asombroso patrimonio de la India, hemos creado colecciones emblemáticas. Cada una le lleva a un mundo diferente.",
      items: [
        { name: "Rajastán Real", desc: "Viva palacios reales, fuertes imponentes y la cultura del desierto.", points: ["Fuerte Amber, Jaipur", "Fuerte Mehrangarh, Jodhpur", "Lagos de Udaipur"] },
        { name: "Tulipán de Oro", desc: "Un viaje por sitios históricos con el confort moderno y estancias de descanso.", points: ["Estancias boutique de lujo", "Experiencias urbanas selectas", "Traslados privados"] },
        { name: "Triángulo de Oro", desc: "La gran confluencia de Delhi, Agra y Jaipur.", points: ["Qutub Minar, Delhi", "Taj Mahal, Agra", "Hawa Mahal, Jaipur"] },
        { name: "Rajastán Patrimonial", desc: "Viva el patrimonio cultural de Rajastán y su estilo de vida tradicional.", points: ["Templo de Brahma, Pushkar", "Templos de Khajuraho"] },
      ],
    },
    tours: { kicker: "La Colección Emblemática", title: "Diez Viajes. Un Alma.", sub: "Cada itinerario es privado, con chófer y totalmente a medida. Elija su viaje — nosotros creamos el resto.", enquire: "Consultar", whatsapp: "WhatsApp", viewTour: "Ver Viaje", priceOnRequest: "Precio a consultar" },
    gallery: { kicker: "La Galería", title: "La India, Cuadro a Cuadro", sub: "Una muestra de los monumentos, fuertes y orillas sagradas que le esperan." },
    testimonials: { kicker: "Historias de Huéspedes", title: "Palabras de Nuestros Viajeros" },
    td: { back: "Todos los Tours", overview: "El Viaje", itinerary: "Itinerario Día a Día", highlights: "Puntos Destacados", inclusions: "Qué Incluye", day: "Día", enquire: "Consultar Este Tour" },
    enquiry: {
      kicker: "Comience Su Viaje",
      title: "Solicite un Presupuesto Privado",
      sub: "Cuéntenos la ruta de sus sueños — nuestro conserje responde en pocas horas con un plan a medida.",
      fields: { name: "Nombre completo", email: "Correo electrónico", phone: "Teléfono / WhatsApp", tour: "Elija un tour", date: "Fecha de viaje preferida", guests: "Huéspedes", tier: "Categoría de hotel", message: "Cuéntenos más (opcional)" },
      tiers: ["Boutique Patrimonial", "Palacio de Lujo", "Signature Real"],
      submit: "Enviar Consulta",
      sending: "Enviando…",
      success: "¡Namaste! Hemos recibido su consulta. Nuestro conserje le contactará en breve.",
      whatsappCta: "Continuar por WhatsApp",
    },
    footer: { tagline: "Descubra el Alma de la India", blurb: "Viajes privados premium por la India — chóferes, palacios y narradores certificados, diseñados a su medida.", explore: "Explorar", contact: "Conserjería", rights: "Todos los derechos reservados." },
    chat: {
      title: "Royal Assistant",
      subtitle: "Conserje oficial de viajes de Explore India",
      greeting: "¡Namaste! Soy Royal Assistant, el conserje oficial de viajes de Explore India. ¿Cómo puedo ayudarle a planear su viaje hoy?",
      placeholder: "Pregunte por tours, precios, itinerarios…",
      send: "Enviar",
      quick: ["¿Precio del Triángulo de Oro?", "¿Mejor época para visitar Rajastán?", "Itinerario familiar de 7 días"],
      error: "No estoy disponible en este momento. Escríbanos por WhatsApp al +91 9252211011.",
    },
    whatsapp: { title: "Conserjería por WhatsApp", labels: ["Experto en Triángulo de Oro", "Especialista en Rajastán Real", "Conserjería 24/7"] },
  },
  fr: {
    nav: { about: "À propos", services: "Services", collections: "Collections", tours: "Circuits", gallery: "Galerie", contact: "Contact", cta: "Réserver un Circuit Privé" },
    hero: {
      kicker: "Explore Indians · Voyages Privés de Luxe",
      lines: ["Découvrez", "l'Âme", "de l'Inde"],
      sub: "Bienvenue pour un voyage incroyable à travers l'Inde — une rencontre rare entre histoire, culture et beauté naturelle. Du charme envoûtant du Taj Mahal à l'héritage royal du Rajasthan, chaque pas révèle une nouvelle expérience.",
      ctaPrimary: "Planifier Mon Voyage",
      ctaSecondary: "Discuter sur WhatsApp",
      badges: ["Guides Certifiés", "Conciergerie 24/7", "100% Sur Mesure"],
      scroll: "Faites défiler pour explorer",
    },
    marquee: ["RAJASTHAN ROYAL", "TRIANGLE D'OR", "CHAUFFEURS PRIVÉS DE LUXE", "GUIDES DU PATRIMOINE CERTIFIÉS", "SÉJOURS PALAIS & HAVELIS", "DÉCOUVREZ L'ÂME DE L'INDE"],
    about: {
      kicker: "À Propos",
      title: "Un Voyage Indien Complet, Conçu pour Vous",
      body: "Nous offrons aux voyageurs en Inde une expérience complète et sans souci. Notre promesse couvre chaque détail :",
      bullets: [
        "Chauffeurs privés expérimentés et fiables",
        "Hôtels patrimoniaux, palais et havelis sélectionnés",
        "Visites guidées de monuments et sites historiques",
        "L'engagement de répondre à chaque besoin de nos hôtes",
      ],
      stats: [
        { n: "10+", l: "Circuits Emblématiques" },
        { n: "7", l: "Destinations Iconiques" },
        { n: "3", l: "Lignes de Conciergerie" },
        { n: "24/7", l: "Assistance aux Hôtes" },
      ],
    },
    services: {
      kicker: "Nos Services Premium",
      title: "Voyagez en Royal",
      items: [
        { title: "Chauffeurs & Voitures Expérimentés", desc: "Pour des trajets sûrs, confortables et ponctuels, notre équipe de chauffeurs courtois et expérimentés connaît chaque route locale intimement." },
        { title: "Hôtels Patrimoniaux & Séjours", desc: "Séjournez dans la splendeur royale — palais et havelis traditionnels réservés spécialement pour vous, pour vivre la riche histoire et l'hospitalité de l'Inde." },
        { title: "Guides Certifiés & Accompagnateurs", desc: "Des guides multilingues agréés par le gouvernement qui font vivre monuments, art et culture — avec des accompagnateurs dévoués tout au long du voyage." },
      ],
    },
    collections: {
      kicker: "Circuits Spéciaux",
      title: "Quatre Mondes de l'Inde",
      sub: "Pour découvrir la diversité et le patrimoine étonnant de l'Inde, nous avons créé des collections signature. Chacune vous emporte dans un monde différent.",
      items: [
        { name: "Rajasthan Royal", desc: "Vivez palais royaux, forts puissants et culture du désert.", points: ["Fort d'Amber, Jaipur", "Fort Mehrangarh, Jodhpur", "Lacs d'Udaipur"] },
        { name: "Tulipe d'Or", desc: "Un voyage à travers les sites historiques avec confort moderne et séjours reposants.", points: ["Séjours boutique de luxe", "Expériences urbaines choisies", "Transferts privés"] },
        { name: "Triangle d'Or", desc: "La grande confluence de Delhi, Agra et Jaipur.", points: ["Qutub Minar, Delhi", "Taj Mahal, Agra", "Hawa Mahal, Jaipur"] },
        { name: "Rajasthan du Patrimoine", desc: "Vivez le patrimoine culturel du Rajasthan et son art de vivre traditionnel.", points: ["Temple de Brahma, Pushkar", "Temples de Khajuraho"] },
      ],
    },
    tours: { kicker: "La Collection Signature", title: "Dix Voyages. Une Âme.", sub: "Chaque itinéraire est privé, avec chauffeur et entièrement sur mesure. Choisissez votre voyage — nous créons le reste.", enquire: "Demander", whatsapp: "WhatsApp", viewTour: "Voir le Voyage", priceOnRequest: "Prix sur demande" },
    gallery: { kicker: "La Galerie", title: "L'Inde, Image par Image", sub: "Un aperçu des monuments, forts et rives sacrées qui vous attendent." },
    testimonials: { kicker: "Récits de Voyageurs", title: "Les Mots de Nos Voyageurs" },
    td: { back: "Tous les Circuits", overview: "Le Voyage", itinerary: "Itinéraire Jour par Jour", highlights: "Points Forts", inclusions: "Ce Qui Est Inclus", day: "Jour", enquire: "Demander Ce Circuit" },
    enquiry: {
      kicker: "Commencez Votre Voyage",
      title: "Demandez un Devis Privé",
      sub: "Dites-nous l'itinéraire de vos rêves — notre concierge répond en quelques heures avec un plan sur mesure.",
      fields: { name: "Nom complet", email: "E-mail", phone: "Téléphone / WhatsApp", tour: "Choisir un circuit", date: "Date de voyage souhaitée", guests: "Voyageurs", tier: "Catégorie d'hôtel", message: "Dites-nous en plus (optionnel)" },
      tiers: ["Boutique Patrimoine", "Palace de Luxe", "Signature Royale"],
      submit: "Envoyer la Demande",
      sending: "Envoi…",
      success: "Namaste ! Votre demande a bien été reçue. Notre concierge vous contactera très vite.",
      whatsappCta: "Continuer sur WhatsApp",
    },
    footer: { tagline: "Découvrez l'Âme de l'Inde", blurb: "Voyages privés premium à travers l'Inde — chauffeurs, palais et conteurs certifiés, conçus pour vous.", explore: "Explorer", contact: "Conciergerie", rights: "Tous droits réservés." },
    chat: {
      title: "Royal Assistant",
      subtitle: "Concierge de voyage officiel d'Explore India",
      greeting: "Namaste ! Je suis Royal Assistant, le concierge officiel d'Explore India. Comment puis-je vous aider à planifier votre voyage aujourd'hui ?",
      placeholder: "Circuits, prix, itinéraires…",
      send: "Envoyer",
      quick: ["Prix du Triangle d'Or ?", "Meilleure saison pour le Rajasthan ?", "Itinéraire famille 7 jours"],
      error: "Je suis momentanément indisponible. Contactez-nous sur WhatsApp au +91 9252211011.",
    },
    whatsapp: { title: "Conciergerie WhatsApp", labels: ["Expert Triangle d'Or", "Spécialiste Rajasthan Royal", "Conciergerie 24/7"] },
  },
};
